import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" {...props}><path fill="#000" d="M10.102 3.6h13.2v1.2h-13.2zM1.699 11.4h21.6v1.2h-21.6zM1.699 19.2h21.6v1.2h-21.6z" /><path fillRule="evenodd" clipRule="evenodd" d="M4.035 4.384L.86 1.21 1.708.36l3.176 3.176L8.059.36l.849.849-3.176 3.175L8.908 7.56l-.849.849-3.175-3.176-3.176 3.176-.849-.849 3.176-3.176z" fill="#000" /></svg>;